import { locale } from '@trqk/utils';

export const MANAGE_GAP_ANALYSIS_HANDLER_KEY = 'createGapAnalysis';

/**
 * Initial context for the gapAnalysisMachine.
 */
export const initialContext: GapAnalysisContext = {
    audioLists: {},
    audiosUpdated: {},
    channels: [],
    channelsUpdated: -1,
    currentChannelId: null,
    edits: {},
    filterOptions: [],
    loading: false,
    logDetails: {},
    mode: 'create',
    periodSelections: [],
    reportDescription: '',
    selectedPeriod: null,
    stepHistory: ['selectPeriod'],
    steps: {
        selectPeriod: {
            id: 'selectPeriod',
            disableNextStep: true,
            disablePreviousStep: false,
            defaultTitle:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.SELECT_PERIOD
                    .DEFAULT_TITLE,
            title: null,
            nextStepId: 'setUp',
            nextStepLabel:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.SELECT_PERIOD
                    .NEXT_BUTTON_LABEL,
            previousStepId: null,
            showDataSources: false,
            statusMessage:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.SELECT_PERIOD.NEXT_STEPS
                    .SELECT_PERIOD_TO_PROCEED,
        },
        setUp: {
            id: 'setUp',
            disableNextStep: true,
            disablePreviousStep: false,
            defaultTitle:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.SET_UP.DEFAULT_TITLE,
            title: null,
            nextStepId: 'analyzingData',
            nextStepLabel:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.SET_UP.NEXT_BUTTON_LABEL,
            previousStepId: 'selectPeriod',
            showDataSources: false,
            statusMessage: null,
        },
        selectOptions: {
            id: 'selectOptions',
            disableNextStep: false,
            disablePreviousStep: false,
            defaultTitle:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.SELECT_OPTIONS
                    .DEFAULT_TITLE,
            title: null,
            nextStepId: 'analyzingData',
            nextStepLabel:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.SELECT_OPTIONS
                    .NEXT_BUTTON_LABEL,
            previousStepId: 'setUp',
            showDataSources: false,
            statusMessage: null,
        },
        analyzingData: {
            id: 'analyzingData',
            disableNextStep: true,
            disablePreviousStep: true,
            defaultTitle:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.ANALYZING_DATA
                    .DEFAULT_TITLE,
            title: null,
            nextStepId: null,
            nextStepLabel: null,
            previousStepId: null,
            showDataSources: false,
            statusMessage: null,
        },
        uploadDetections: {
            id: 'uploadDetections',
            disableNextStep: true,
            disablePreviousStep: false,
            defaultTitle:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.UPLOAD_DETECTIONS
                    .DEFAULT_TITLE,
            title: null,
            nextStepId: null,
            nextStepLabel: null,
            previousStepId: 'setUp',
            showDataSources: false,
            statusMessage: null,
        },
        confirmChannels: {
            id: 'confirmChannels',
            disableNextStep: true,
            disablePreviousStep: false,
            defaultTitle:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.CONFIRM_CHANNELS
                    .DEFAULT_TITLE,
            title: null,
            nextStepId: null,
            nextStepLabel:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.CONFIRM_CHANNELS
                    .NEXT_BUTTON_LABEL,
            previousStepId: null,
            showDataSources: true,
            statusMessage: null,
        },
        confirmWorks: {
            id: 'confirmWorks',
            disableNextStep: true,
            disablePreviousStep: false,
            defaultTitle:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.CONFIRM_WORKS
                    .DEFAULT_TITLE,
            title: null,
            // When the user clicks "Apply", we apply any updates, refetch data and re-render the
            // table of works, but we do not send them to a different step.
            nextStepId: 'confirmWorks',
            nextStepLabel:
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.CONFIRM_WORKS
                    .NEXT_BUTTON_LABEL,
            previousStepId: 'confirmChannels',
            showDataSources: true,
            statusMessage: null,
        },
    },
    statementId: null,
    trqkGap: null,
    uploadedDetectionFile: null,
};
